/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/VideoInTextTeaser/theme';

export const VideoInTextTeaserTheme = theme;
